import axios from 'axios';

// Helper to get config safely
const getConfig = () => {
  return window.APP_CONFIG || {};
};

class BackendService {
  constructor() {
    this.instance = null;
  }

  // Lazy initialization to ensure window.APP_CONFIG is loaded
  getInstance() {
    if (!this.instance) {
      const config = getConfig();
      this.instance = axios.create({
        baseURL: config.API_BASE_URL || '/api',
        timeout: 10000,
        headers: {
          'Content-Type': 'application/json'
        }
      });

      // Request interceptor
      this.instance.interceptors.request.use(
        config => {
          // Add token if needed
          // const token = localStorage.getItem('token');
          // if (token) {
          //   config.headers['Authorization'] = `Bearer ${token}`;
          // }
          return config;
        },
        error => {
          return Promise.reject(error);
        }
      );

      // Response interceptor
      this.instance.interceptors.response.use(
        response => {
          const res = response.data;
          // Check business code
          if (res.code === 1) {
            // Return the payload directly
            return res.data;
          } else {
            // Handle business error
            console.error('API Business Error:', res.msg);
            return Promise.reject(new Error(res.msg || 'Unknown Error'));
          }
        },
        error => {
          console.error('Backend API Error:', error);
          return Promise.reject(error);
        }
      );
    }
    return this.instance;
  }

  get(url, params = {}) {
    return this.getInstance().get(url, { params });
  }

  post(url, data = {}) {
    return this.getInstance().post(url, data);
  }

  put(url, data = {}) {
    return this.getInstance().put(url, data);
  }

  delete(url, params = {}) {
    return this.getInstance().delete(url, { params });
  }
}

export default new BackendService();
